import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

// import reduxLogger from 'redux-logger';
import { apiMiddleware } from 'redux-api-middleware';
import dailyShifts from './dailyShifts';
import employees from './employees';
import report from './report';
import user from './user';
import myShifts from './myShifts';

const rootReducer = combineReducers({
  dailyShifts,
  employees,
  report,
  user,
  myShifts,
});

const store = createStore(
  rootReducer,
  applyMiddleware(thunk, apiMiddleware /*, reduxLogger*/),
);

export default store;
